import "./ReportStatus.scss";

import type { OptionType } from "components/inputs";
import React from "react";
import { formatCurrency } from "utils/format-utils";

type ReportStatusProps = {
  isLoading: boolean;
  lastRunTime?: Date | null;
  reportType: OptionType | null;
  reportMeta: Record<string, unknown> | null;
  showReportTable: boolean;
};

// component that shows the report status (last run time, total amount)
const ReportStatus: React.FC<ReportStatusProps> = ({
  isLoading,
  lastRunTime,
  reportType,
  reportMeta,
  showReportTable,
}) => {
  // check if we should show total amount (only for Invoice Line Item Report, WIP report, and Invoice List)
  const shouldShowTotal =
    reportMeta?.total_Amount &&
    (reportType?.value === "INVOICE_LINE_ITEM_REPORT" ||
      reportType?.value === "WORK_IN_PROGRESS" ||
      reportType?.value === "INVOICE_LIST");

  const totalAmount = shouldShowTotal ? Number(reportMeta.total_Amount) : 0;

  return (
    <div className="report-status-section">
      <div className="report-status-content">
        {/* show content only if loading or report has been run */}
        {(showReportTable || isLoading) && (
          <div className="status-row status-inline">
            <div className="status-group">
              <span
                className={`material-icons status-icon ${!isLoading ? "status-icon--completed" : ""}`}
              >
                {isLoading ? "hourglass_empty" : "check_circle"}
              </span>
              <span className="status-label">
                {isLoading ? "Loading..." : "Last run:"}
              </span>
              {lastRunTime && !isLoading && (
                <span className="status-value">
                  {new Date(lastRunTime).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              )}
            </div>

            {/* total amount (only for specific reports) */}
            {shouldShowTotal && !isLoading && (
              <div className="status-group">
                <span className="status-label-bold">Total:</span>
                <span className="status-value-bold">
                  {formatCurrency(totalAmount)}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportStatus;
